import React from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import Navbar from '../common/Navbar';
import Sidebar from '../common/Sidebar';
import { useAuth } from '../../context/AuthContext';

const StaffLayout = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isLocationcontain =  location.pathname.includes('dashboard') && !location.pathname.includes('certificate');
  const handleLogout = async () => {
    await logout();
    navigate('/login');
  };

  const staffNavItems = [
    { label: 'Dashboard', path: '/staff/dashboard', icon: <i className="bi bi-grid-fill"></i> },
    { label: 'My Courses', path: '/staff/courses', icon: <i className="bi bi-book"></i> },
    { label: 'Updates', path: '/staff/updates', icon: <i className="bi bi-rss"></i> },
    { label: 'Policy Management', path: '/staff/policies', icon: <i className="bi bi-shield-lock"></i> },
    { label: 'Leaderboard', path: '/staff/leaderboard', icon: <i className="bi bi-bar-chart-line"></i> },
    { label: 'Profile', path: '/staff/profile', icon: <i className="bi bi-person"></i> },
  ];

  return (
    <div className="staff-layout d-flex">
    {/* Sidebar always on the left, full height */}
    <Sidebar navItems={staffNavItems} onLogout={handleLogout} />
  
    {/* Right side: content area (navbar + main content) */}
    <div className="content-wrapper flex-grow-1 d-flex flex-column">
    {
      isLocationcontain &&
      <Navbar 
      username={user?.fullName}
      userRole={user?.role}
      onLogout={handleLogout}
    />

    }
    
  
      <main className="main-content flex-grow-1">
        <Outlet />
      </main>
    </div>
  </div>
  );
};

export default StaffLayout;